var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:_vm.modalName,attrs:{"id":_vm.modalName,"title":_vm.title,"hide-header":_vm.onlyBody,"hide-footer":_vm.onlyBody,"ok-title":_vm.okTitle,"cancel-title":_vm.cancelTitle,"ok-variant":_vm.okVariant,"cancel-variant":_vm.cancelVariant},on:{"show":_vm.open,"hidden":_vm.close,"ok":_vm.ok}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }